import moment from "moment";
import { instance } from "./session/axios";
import { saveReload } from "./SessionStorage";

const gettingTimecard = async (
  setLoading,
  range,
  employees,
  setRows,
  handlerAlert,
) => {
  if (JSON.parse(sessionStorage.getItem("privileges")).overtime.get_timecard) {
    setLoading(true);

    const body = {
      start_date: range[0].format("YYYY-MM-DD"),
      end_date: range[1].format("YYYY-MM-DD"),
      employees: [...new Set(employees.map((employee) => employee.id))],
    };

    try {
      const response = await instance.post("timecard/multi_read", body);
      const rows = [];

      for (let person_number of Object.keys(response.data.daily_totals)) {
        for (let date of Object.keys(
          response.data.daily_totals[person_number],
        )) {
          if (
            response.data?.daily_totals?.[person_number]?.[date]?.totals?.[
              "HORAS POR APROBAR"
            ]
          ) {
            const pendingOvertime =
              response.data?.daily_totals?.[person_number]?.[date]?.totals?.[
                "HORAS POR APROBAR"
              ];
            rows.push({
              id: `${person_number}-${date}-pending`,
              person_number: person_number,
              full_name: employees.find(
                (employee) => employee.id === person_number,
              )?.full_name,
              date: date,
              shifts: [],
              punches: response.data?.punches?.[person_number]?.[date]
                ? response.data?.punches?.[person_number]?.[date]
                : [],
              action: "",
              comment: pendingOvertime?.comment || undefined,
              notes: pendingOvertime?.notes || "",
              partial_amount: "00:00",
              amount: moment(pendingOvertime?.amount_in_time, [
                "HH:mm",
                "H:mm",
              ]).format("HH:mm"),
              status: "pending",
            });
          }

          if (
            response.data?.daily_totals?.[person_number]?.[date]?.totals?.[
              "EM HORAS RECHAZADAS"
            ]
          ) {
            const rejectedOvertime =
              response.data?.daily_totals?.[person_number]?.[date]?.totals?.[
                "EM HORAS RECHAZADAS"
              ];
            let amount = moment(rejectedOvertime?.amount_in_time, [
              "HH:mm",
              "H:mm",
            ]).format("HH:mm");

            if (
              response.data?.daily_totals?.[person_number]?.[date]?.totals?.[
                "EM HORAS APROBADAS"
              ]
            ) {
              const time_approved = moment
                .duration(
                  response.data?.daily_totals?.[person_number]?.[date]
                    ?.totals?.["EM HORAS APROBADAS"]?.amount_in_time,
                )
                .asMinutes();
              amount = moment(rejectedOvertime?.amount_in_time, [
                "HH:mm",
                "H:mm",
              ])
                .add(time_approved, "minutes")
                .format("HH:mm");
            }

            rows.push({
              id: `${person_number}-${date}-rejected`,
              person_number: person_number,
              full_name: employees.find(
                (employee) => employee.id === person_number,
              )?.full_name,
              date: date,
              shifts: [],
              punches: response.data?.punches?.[person_number]?.[date]
                ? response.data?.punches?.[person_number]?.[date]
                : [],
              action: response.data?.daily_totals?.[person_number]?.[date]
                ?.totals?.["EM HORAS APROBADAS"]
                ? "some"
                : "none",
              comment: rejectedOvertime?.comment || undefined,
              notes: rejectedOvertime?.notes || "",
              partial_amount: moment(rejectedOvertime?.amount_in_time, [
                "HH:mm",
                "H:mm",
              ]).format("HH:mm"),
              amount: amount,
              status: "rejected",
            });
          }

          if (
            response.data?.daily_totals?.[person_number]?.[date]?.totals?.[
              "EM HORAS APROBADAS"
            ]
          ) {
            const approvedOvertime =
              response.data?.daily_totals?.[person_number]?.[date]?.totals?.[
                "EM HORAS APROBADAS"
              ];
            let amount = moment(approvedOvertime?.amount_in_time, [
              "HH:mm",
              "H:mm",
            ]).format("HH:mm");

            if (
              response.data?.daily_totals?.[person_number]?.[date]?.totals?.[
                "EM HORAS RECHAZADAS"
              ]
            ) {
              const time_rejected = moment
                .duration(
                  response.data?.daily_totals?.[person_number]?.[date]
                    ?.totals?.["EM HORAS RECHAZADAS"]?.amount_in_time,
                  ["HH:mm", "H:mm"],
                )
                .asMinutes();
              amount = moment(approvedOvertime?.amount_in_time, [
                "HH:mm",
                "H:mm",
              ])
                .add(time_rejected, "minutes")
                .format("HH:mm");
            }

            rows.push({
              id: `${person_number}-${date}-approved`,
              person_number: person_number,
              full_name: employees.find(
                (employee) => employee.id === person_number,
              )?.full_name,
              date: date,
              shifts: [],
              punches: response.data?.punches?.[person_number]?.[date]
                ? response.data?.punches?.[person_number]?.[date]
                : [],
              action: response.data?.daily_totals?.[person_number]?.[date]
                ?.totals?.["EM HORAS RECHAZADAS"]
                ? "some"
                : "all",
              comment: approvedOvertime?.comment || undefined,
              notes: approvedOvertime?.notes || "",
              partial_amount: moment(approvedOvertime?.amount_in_time, [
                "HH:mm",
                "H:mm",
              ]).format("HH:mm"),
              amount: amount,
              status: "approved",
            });
          }
        }
      }

      const userData = JSON.parse(sessionStorage.getItem("account"));
      const user_id = userData?.id;

      if (!user_id) {
        setRows(rows);
        setLoading(false);
        return;
      }

      const nonPendingRows = rows.filter((row) => row.status !== "pending");
      const uniqueDates = [...new Set(nonPendingRows.map((row) => row.date))];

      const auditsByDate = {};

      for (const date of uniqueDates) {
        try {
          const response = await instance.get("audits", {
            params: {
              user_id: user_id,
              start_date: date,
              end_date: date,
              search_by: "event_date",
              type: "Overtime",
            },
          });

          const audits = response.data;
          const auditMap = {};

          const auditEntries = Object.entries(audits).sort((a, b) => {
            const timeA = new Date(a[1].timestamp).getTime();
            const timeB = new Date(b[1].timestamp).getTime();
            return timeB - timeA;
          });

          for (const [, audit] of auditEntries) {
            const personNumber = audit.employee || audit.params?.person_number;

            if (personNumber && !auditMap[personNumber]) {
              auditMap[personNumber] = {
                comment: audit.params?.comment || undefined,
                notes: audit.params?.notes || "",
              };
            }
          }

          auditsByDate[date] = auditMap;
        } catch (error) {
          console.error(`Error getting audits for date ${date}:`, error);
          auditsByDate[date] = {};
        }
      }

      for (const row of rows) {
        if (
          row.status !== "pending" &&
          auditsByDate[row.date]?.[row.person_number]
        ) {
          const auditData = auditsByDate[row.date][row.person_number];
          row.comment = auditData.comment;
          row.notes = auditData.notes;
        }
      }

      setRows(rows);
    } catch (error) {
      handlerAlert(
        "overtime.table.alerts.error_get_timecard.title",
        "overtime.table.alerts.error_get_timecard.message",
        "error",
      );
    } finally {
      setLoading(false);
    }
  } else {
    handlerAlert(
      "overtime.table.alerts.get_timecard.title",
      "overtime.table.alerts.get_timecard.message",
      "error",
    );
  }
};

const gettingSchedule = async (
  setLoading,
  range,
  employees,
  setRows,
  handlerAlert,
) => {
  if (JSON.parse(sessionStorage.getItem("privileges")).overtime.get_schedule) {
    setLoading(true);

    const body = {
      start_date: range[0].format("YYYY-MM-DD"),
      end_date: range[1].format("YYYY-MM-DD"),
      employees: [...new Set(employees.map((employee) => employee.id))],
    };

    await instance
      .post("schedule/multi_read", body)
      .then((response) => {
        setRows((prev) => {
          for (const row of prev) {
            row.shifts = response.data?.[row.person_number]?.["shifts"]?.[
              row.date
            ]
              ? response.data?.[row.person_number]?.["shifts"]?.[row.date]
              : [];
          }

          return prev;
        });
      })
      .catch((error) => {
        handlerAlert(
          "overtime.table.alerts.error_get_schedule.title",
          "overtime.table.alerts.error_get_schedule.message",
          "error",
        );
      })
      .finally(() => {
        setLoading(false);
      });
  } else {
    handlerAlert(
      "overtime.table.alerts.get_schedule.title",
      "overtime.table.alerts.get_schedule.message",
      "error",
    );
  }
};

const applyingOvertime = async (
  setLoading,
  overtimes,
  closing,
  reloading,
  handlerAlert,
) => {
  setLoading(true);

  if (
    JSON.parse(sessionStorage.getItem("privileges")).overtime
      .add_approve_overtime ||
    JSON.parse(sessionStorage.getItem("privileges")).overtime
      .remove_approve_overtime
  ) {
    // console.log('overtimes', overtimes)

    await instance
      .post("overtime/approve", {
        overtimes: overtimes.map((overtime) => ({
          person_number: overtime.person_number,
          date: overtime.date,
          action: overtime.action,
          amount: moment.duration(overtime.partial_amount).asHours(),
          comment:
            overtime.comment && overtime.comment.trim() !== ""
              ? overtime.comment
              : undefined,
          notes:
            overtime.notes && overtime.notes.trim() !== ""
              ? overtime.notes
              : overtime.note && overtime.note.trim() !== ""
              ? overtime.note
              : undefined,
        })),
      })
      .then((response) => {
        closing();
        reloading();
      })
      .catch((error) => {
        handlerAlert(
          "overtime.table.alerts.error_managed_overtime.title",
          "overtime.table.alerts.error_managed_overtime.message",
          "error",
        );
      })
      .finally(() => {
        setLoading(false);
      });
  } else {
    handlerAlert(
      "overtime.table.alerts.manage_overtime.title",
      "overtime.table.alerts.manage_overtime.message",
      "error",
    );
  }
};

const gettingOvertimeAuditByDate = async (user_id, date, person_number) => {
  try {
    const response = await instance.get("audits", {
      params: {
        user_id: user_id,
        start_date: date,
        end_date: date,
        search_by: "event_date",
        type: "Overtime",
      },
    });

    const audits = response.data;

    for (const auditId in audits) {
      const audit = audits[auditId];
      if (
        audit.employee === person_number ||
        audit.params?.person_number === person_number
      ) {
        return {
          comment: audit.params?.comment || undefined,
          notes: audit.params?.notes || "",
        };
      }
    }

    return {
      comment: undefined,
      notes: "",
    };
  } catch (error) {
    return {
      comment: undefined,
      notes: "",
    };
  }
};

const gettingOpenPeriod = async (
  setLoading,
  range,
  employees,
  smartgroups,
  view,
  rows,
  setPeriods,
  handlerAlert,
) => {
  if (
    JSON.parse(sessionStorage.getItem("privileges")).overtime.get_open_period
  ) {
    setLoading(true);

    const body = {
      start_date: range[0].format("YYYY-MM-DD"),
      end_date: range[1].format("YYYY-MM-DD"),
      employees: [...new Set(employees.map((employee) => employee.id))],
    };

    await instance
      .post("person/multi_read", body)
      .then((response) => {
        const periods = [];

        for (let person_number of Object.keys(response.data)) {
          for (let row of rows.filter(
            (row) => row.person_number === person_number,
          )) {
            row.open_period = {
              open: moment(
                response?.data?.[person_number]?.person_data
                  ?.mgr_sign_off_thru_datetime,
                ["YYYY-MM-DD", "DD/MM/YYYY"],
              ).isBefore(moment(row.date, ["YYYY-MM-DD", "DD/MM/YYYY"])),
              end_date: moment(
                response?.data?.[person_number]?.person_data
                  ?.mgr_sign_off_thru_datetime,
                ["YYYY-MM-DD", "DD/MM/YYYY"],
              ).format("YYYY-MM-DD"),
            };
          }

          periods.push({
            full_name: `${response?.data?.[person_number]?.person_data?.full_name} - (${person_number})`,
            person_number,
            end_date: moment(
              response?.data?.[person_number]?.person_data
                ?.mgr_sign_off_thru_datetime,
              ["YYYY-MM-DD", "DD/MM/YYYY"],
            ).format("YYYY-MM-DD"),
          });
        }

        setPeriods(periods);

        saveReload(
          view,
          range[0].format("YYYY-MM-DD"),
          range[1].format("YYYY-MM-DD"),
          [...new Set(smartgroups.map((smartgroup) => smartgroup.id))],
          employees,
        );
      })
      .catch((error) => {
        console.error(error.message);
      })
      .finally(() => {
        const data = JSON.parse(sessionStorage.getItem(view));

        if (data) {
          sessionStorage.setItem(
            view,
            JSON.stringify({
              ...data,
              environment: data?.environment ? data.environment : null,
              redirect: null,
            }),
          );
        }

        setLoading(false);
      });
  } else {
    handlerAlert(
      "overtime.table.alerts.get_open_period.title",
      "overtime.table.alerts.get_open_period.message",
      "error",
    );
  }

  return rows;
};

export {
  gettingTimecard,
  gettingSchedule,
  applyingOvertime,
  gettingOvertimeAuditByDate,
  gettingOpenPeriod,
};
